import Client from 'modules/Client'

export default {
  fetchAll (params) {
    return Client.get('api/aluno/ingresso', { params })
  }
}
